import { createSelector } from "reselect";
import get from "lodash/get";

const submitSuspensionDomain = state => get(state, "api.submitSuspension", {});

// ***************************************************************
// **************** submitSuspension selectors **********************
// ***************************************************************

export const submitSuspensionErrorSelector = createSelector(
  submitSuspensionDomain,
  submitSuspension => get(submitSuspension, "error")
);

// ***************************************************************
// *************** submitSuspension makeSelect **********************
// ***************************************************************

export const makeSelectSubmitSuspensionError = () =>
  submitSuspensionErrorSelector;
